import React from 'react';
import { MapPinIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
const ITEMS = [{
  icon: MapPinIcon,
  label: 'Serving Manhattan, Queens & Long Island'
}, {
  icon: ShieldCheckIcon,
  label: 'Insured & Bonded'
}, {
  icon: StarIcon,
  label: '5-Star Google Rated'
}];
export function TrustBar() {
  return <section className="w-full bg-slate-50 border-y border-slate-100" data-id="element-270" data-mp="13826uir7rbqq">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6" data-id="element-271" data-mp="1qyg2skcx5uql">
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:divide-x sm:divide-slate-200" data-id="element-272" data-mp="1uyzuh8eq465c">
          {ITEMS.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center justify-center gap-3 px-4 text-center" data-id="element-273" data-mp="1gyfeek070ofj">
              <Icon className="h-5 w-5 shrink-0 text-sky-brand" strokeWidth={2} data-id="element-274" data-mp="1m04rs6aw1e6s" />
              <span className="text-sm font-medium text-slate-soft" data-id="element-275" data-mp="ajo820sawbe4">
                {label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}